import { render, staticRenderFns } from "./DeviceAdmin.vue?vue&type=template&id=12cce1ca&scoped=true&"
import script from "./DeviceAdmin.vue?vue&type=script&lang=js&"
export * from "./DeviceAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DeviceAdmin.vue?vue&type=style&index=0&id=12cce1ca&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cce1ca",
  null
  
)

export default component.exports